import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getNavTarget } from 'support/navHelper';
import useTracking from 'hooks/analytics';
import { useVideoById } from 'hooks/video';
import { isLiveVideo } from 'support/videoHelper';
import { Platform, TypeIdKeys } from 'app-types';
import { KitcenSinkRowItemDataItem } from '../store-types';

interface TrackingPageData {
  edenBarLaunch: string;
  deepLink: string;
  [key: string]: unknown;
}

const trackEdenBarDeepLink = (
  tracker: (action: string, pageData?: TrackingPageData) => void,
  { rawDeepLinkUrl, video }: { rawDeepLinkUrl: string; video: KitcenSinkRowItemDataItem | null },
) => {
  const isLive = isLiveVideo(video);
  const action = isLive ? 'edenbar-watch stream' : 'edenbar-highlights';
  const pageData = {
    edenBarLaunch: 'true',
    deepLink: `public preview|${rawDeepLinkUrl}|${video?.id}`,
  };

  tracker(action, pageData);
};

export const useDeeplink = (
  platform: Platform,
  callback: (target: TypeIdKeys) => void,
): void => {
  const latestCallbackRef = useRef(callback);
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();

  useEffect(() => {
    latestCallbackRef.current = callback;
  }, [callback]);

  const [videoId, setVideoId] = useState<string | null>(null);
  const [deeplinkUrl, setDeeplinkUrl] = useState<string | null>(null);
  const [triggerTrackEvent, setTrackEvent] = useState(false);
  const video = useVideoById(videoId);

  useEffect(() => {
    if (video[0] && deeplinkUrl && triggerTrackEvent) {
      // @ts-ignore - TODO: Fix this bug
      trackEdenBarDeepLink(trackEvent, { deeplinkUrl, video: video[0] as KitcenSinkRowItemDataItem });
      setTrackEvent(false);
    }
  }, [video, trackEvent, deeplinkUrl, triggerTrackEvent]);

  useEffect(() => {
    if (platform === 'samsung-tizen') {
      const deepLink = () => {
        const requestedAppControl = window.tizen.application
          .getCurrentApplication()
          .getRequestedAppControl();

        if (requestedAppControl) {
          const appControlData = requestedAppControl.appControl.data;
          const payloadData = appControlData.find(
            data => data.key === 'PAYLOAD',
          );

          if (payloadData) {
            const actionData = JSON.parse(payloadData.value[0]).values;
            const url = actionData.replace(/cbssports:\/\S+samsung\//g, '');
            const target = getNavTarget(url);
            if (target && target.type) {
              setVideoId(target.id);
              setDeeplinkUrl(actionData);
              setTrackEvent(true);
              latestCallbackRef.current(target);
            }
          }
        }
      };
      deepLink();
      window.addEventListener('appcontrol', deepLink);
    }
  }, [platform, dispatch, trackEvent]);
};
